module.exports = __webpack_public_path__ + "9195b8bf061925a612392e452f64ae38.pdf";